module.exports = __webpack_public_path__ + "img/sk-icon-01.dbc1efb0.png";